import { Link } from '@chakra-ui/react';
import { getButtonLabel,getCompositeLabel } from './utils';
import { updateBulletData } from '../utils';

const BulletButton = ({ jobSeekerData, stateProps, option, index, labelPart }) => {

  const buttonLabels = getButtonLabel(jobSeekerData,stateProps,option);
  let buttonLabel = Array.isArray(buttonLabels) ? getCompositeLabel(buttonLabels): buttonLabels;
  if (buttonLabel === '') {
    buttonLabel = ' _ ';
  }
  if(labelPart === '') {
    if(option.type === 'freeform' && typeof buttonLabel === 'undefined') {
      buttonLabel = 'add text';
    }
    const firstLetter = buttonLabel[0].toUpperCase();
    const  remainder = buttonLabel.slice(1);
    buttonLabel = firstLetter+remainder;
  }
  return (
  <Link
    sx={{ color: 'NAVY', background:'blanchedalmond'}}
    onClick={e => {
      option.index = index;
     updateBulletData({bulletModal:option},stateProps);
      stateProps.onBulletOpen(e);
    }}
  >
    {buttonLabel}</Link>
  )
}
export default BulletButton;